export default {
  path: '/coupon',
  meta: {
    title: '拼团券',
    tab:true
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/coupon`),
}



// WEBPACK FOOTER //
// ./src/views/Coupon/router.js